<div *ngIf="unusedDisks.length" class="cards">
  <ix-unused-disk-card
    class="unused-resources"
    [pools]="pools"
    [unusedDisks]="unusedDisks"
  ></ix-unused-disk-card>
</div>
